import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormField from '../../../components/FormField'
import ConnectedCourseRow from './ConnectedCourseRow'
import { connectEditCourse } from '../actions'

class ConnectedCoursesTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      newCourse: {
        courseNum: '',
        descr: '',
        thumbnailUri: '',
      },
    }
  }

  handleCourseChange = event => {
    let {
      target: { name, value },
    } = event
    this.setState({
      newCourse: {
        ...this.state.newCourse,
        [name]: value,
      },
    })
  }

  handleSave = () => {
    this.props.toggleFunc()
    this.props.connectCourse(this.props.selectedOrgId, this.state.newCourse)
    this.setState({
      newCourse: {
        courseNum: '',
        descr: '',
        thumbnailUri: '',
      },
    })
  }

  render() {
    let newRow = this.props.addNew ? (
      <tr>
        <td>
          <FormField
            name="courseNum"
            label={null}
            value={this.state.newCourse.courseNum}
            handler={this.handleCourseChange}
            type="text"
          />
        </td>
        <td>
          <FormField
            name="descr"
            label={null}
            value={this.state.newCourse.descr}
            handler={this.handleCourseChange}
            type="text"
          />
        </td>
        <td>
          <FormField
            name="thumbnailUri"
            label={null}
            value={this.state.newCourse.thumbnailUri}
            handler={this.handleCourseChange}
            type="text"
          />
        </td>
        <td />
        <td className="text-right">
          <button onClick={this.handleSave} className="btn btn-primary">
            Save
          </button>
        </td>
      </tr>
    ) : null

    return (
      <table className="table">
        <thead>
          <tr>
            <th>Course Number</th>
            <th>Description</th>
            <th>Thumbnail URI</th>
            <th>Current Revision</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {newRow}
          {this.props.connectedCourses.map((course, i) => {
            return (
              <ConnectedCourseRow
                courseId={course.id}
                coursenum={course.coursenum}
                descr={course.descr}
                thumbnailUri={course.thumbnailUri}
                revision={course.currentRev}
                key={i}
              />
            )
          })}
        </tbody>
      </table>
    )
  }
}

ConnectedCoursesTable.propTypes = {
  addNew: PropTypes.bool,
  connectCourse: PropTypes.func,
  selectedOrgId: PropTypes.string,
  connectedCourses: PropTypes.array,
  toggleFunc: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    selectedOrgId: state.selectedOrgId,
    connectedCourses: state.connectedCourses,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    connectCourse: (orgId, courseData) => {
      dispatch(connectEditCourse(orgId, courseData))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedCoursesTable)
